<template>
  <CardPrimary :style="style.card">
    <template v-if="isLoading">
      <LoaderPrimary
        :loading="true"
        :style="style.loader"
      />
    </template>
    <template v-else-if="requiredSkills.length > 0">
      <div
        v-for="(requiredSkill, index) in requiredSkills"
        :key="index"
      >
        <TagBinaryStatus
          :disabled="viewOnly"
          :on="!requiredSkill.missed"
          @close="deleteRequiredSkill(requiredSkill)"
          :style="style.tag"
        >
          {{ requiredSkill.label }}
        </TagBinaryStatus>
      </div>
    </template>
    <template v-else>
      <div :style="style.placeholderContainer">
        No required skill is registered yet.
      </div>
    </template>
  </CardPrimary>
</template>

<script>
  import CardPrimary from '@modules/card/card-primary'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import TagBinaryStatus from '@modules/tag/tag-binary-status'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'RequiredSkills',
    components: {
      CardPrimary,
      LoaderPrimary,
      TagBinaryStatus,
    },
    props: {
      isLoading: { type: Boolean, required: false, default: false },
      requiredSkills: { type: Array, required: false, default: () => [] },
      viewOnly: { type: Boolean, required: false, default: true },
    },
    data: function () {
      return {
        style: {
          card: {
            display: 'flex',
            flexWrap: 'wrap',
            height: '100%',
            overflowY: 'scroll',
            padding: '12px',
            width: '100%',
          },
          loader: {
            height: '100%',
            width: '100%',
          },
          placeholderContainer: {
            padding: `0 ${Layout.space.xs}`,
          },
          tag: {
            margin: Layout.space.xs,
          },
        },
      };
    },
    created: function () {
      this.style.placeholder = {
        ...this.style.placeholder,
        color: this.color.dark3(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      deleteRequiredSkill: function (requiredSkill) {
        this.$emit('delete-required-skill', requiredSkill);
      },
    },
  };
</script>
